<template>
  <div 
    ref="root"
    class="zoom-on-hover" 
    v-bind:class="{zoomed}" 
    @click="onZoom"
    @mousemove="move" 
  >
    <div ref="normalImage">    
      <ImageField :key="imgNormal" class="normal" :obj="{'url':imgNormal,'alt':imgAlt,'width':'1500','height':'1500'}" width-param="width" sizes="1500px" :load="imgIndex === 0 ? true: false"/>
    </div>
    <div ref="zoomImage">    
      <ImageField :key="imgZoom || imgNormal" class="zoom" :obj="{'url':imgZoom || imgNormal,'alt':imgAlt,'width':'1500','height':'1500'}" width-param="width" sizes="1500px"/>
    </div>
  </div>
</template>

<script setup>
  import { toRefs, ref, onMounted, onUpdated, onBeforeUnmount } from 'vue';
  import ImageField from './image.vue'

  const props = defineProps({
		imgNormal: { 
      type: String, 
      default: '' 
    },
		imgZoom: { 
      type: String, 
      default: '' 
    },
    imgAlt: { 
      type: String, 
      default: '' 
    },
		scale: { 
      type: Number, 
      default: 1.5 
    },
    disabled: { 
      type: Boolean, 
      default: false 
    },
    imgIndex: { 
      type: Number, 
      default: '' 
    },
  })

  const {
    imgNormal,
    imgZoom,
    scale,
    disabled
  } = toRefs(props)

  var scaleFactor = ref(1.5)
  var resizeCheckInterval = ref(null)
  var zoomed = ref(false)
  var root = ref(null)
  var zoomImage = ref(null)
  var normalImage = ref(null)

  onMounted(() => {
    // if (scale.value) {
    //   scaleFactor.value = scale.value
    //   zoomImage.value.querySelector('picture').style.transform = "scale(" + scaleFactor.value + ")"
    // }
    initEventLoaded()
    initEventResized()
  })

  onUpdated(() => {
    initEventLoaded()
  })

  onBeforeUnmount(() => {
    resizeCheckInterval.value && clearInterval(resizeCheckInterval.value)
  })

  function touchzoom(event){
    if(disabled.value) return
    move(event)
    zoomed.value = !zoomed.value
  }

  function onZoom(){
    if(!disabled.value && window.innerWidth > 1023){
      zoomed.value = !zoomed.value
    }   
  }

  function onUnzoom(){
    if(!disabled.value){
      zoomed.value = false
    } 
  }

  function move(event){
    if(disabled.value || !zoomed.value) return
    var offset = pageOffset(root.value)
    var zoom = zoomImage.value.querySelector('picture')
    var normal = normalImage.value.querySelector('img')
    var relativeX = event.clientX - offset.x + window.pageXOffset
    var relativeY = event.clientY - offset.y + window.pageYOffset
    var normalFactorX = relativeX / normal.offsetWidth
    var normalFactorY = relativeY / normal.offsetHeight
    var x = normalFactorX * (zoom.offsetWidth * scaleFactor.value - normal.offsetWidth)
    var y = normalFactorY * (zoom.offsetHeight * scaleFactor.value - normal.offsetHeight)
    zoom.style.left = -x + "px"
    zoom.style.top = -y + "px"
  }

  function initEventLoaded() {
    // emit the "loaded" event if all images have been loaded
    var promises = [zoomImage.value, normalImage.value].map(function(image) {
      return new Promise(function(resolve, reject) {
        image.addEventListener("load", resolve)
        image.addEventListener("error", reject)
      })
    })
    // var component = this
    Promise.all(promises).then(function(e) {
      // component.$emit("loaded")
    })
  }

  function initEventResized() {
    var normal = normalImage.value.querySelector('img')
    var previousWidth = normal.offsetWidth
    var previousHeight = normal.offsetHeight
    // var component = this
    resizeCheckInterval.value = setInterval(function() {
      if ((previousWidth != normal.offsetWidth) || (previousHeight != normal.offsetHeight)) {
        previousWidth = normal.offsetWidth
        previousHeight = normal.offsetHeight
        window.addEventListener('resize', {
          width: normal.width,
          height: normal.height,
          fullWidth: normal.naturalWidth,
          fullHeight: normal.naturalHeight
        })
      }
    }, 1000)
  }

  function pageOffset(el) {
    // -> {x: number, y: number}
    // get the left and top offset of a dom block element
    var rect = el.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
      y: rect.top + scrollTop,
      x: rect.left + scrollLeft
    }
  }
</script>

<style>
  .zoom-on-hover {
    position: relative;
    overflow: hidden;
  }
  .zoom-on-hover .normal {
    width: 100%;
  }

  .zoom-on-hover.zoomed{
    max-height: unset;
  }
  
  .zoom-on-hover .zoom {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    transform-origin: top left;
    transform: scale(1.5);
  }
  .zoom-on-hover.zoomed .zoom {
    opacity: 1;
    cursor: zoom-out;
  }
  .zoom-on-hover.zoomed .normal {
    opacity: 0;
  }
</style>